export class AuthorChildUpdater {
  constructor(coursenum) {
    this.coursenum = coursenum
  }

  attach() {
    var self = this

    /*
     * Select or deselect all rows in the child-courses table
     */
    $('input#select-all').change(function () {
      var checked = $(this).prop('checked')
      $(this)
        .closest('table')
        .find('input.select-child-course')
        .each(function () {
          $(this).prop('checked', checked)
        })
      self.updateCoursesButtonState(checked)
    })

    /*
     * Update the `#select-all` checkbox whenever a `.select-child-course` checkbox changes
     * and update the `#update-courses` button whenever any checkbox is selected
     */
    $('#child-courses').on('change', 'input.select-child-course', () => {
      var selectedCourses = $('input.select-child-course')
        .toArray()
        .map(function (el) {
          return $(el).prop('checked')
        })
      // toggle the `#select0`
      var toggle = selectedCourses.every(function (checked) {
        return checked
      })
      $('input#select-all').prop('checked', toggle)
      var enableUpdate = selectedCourses.some(function (checked) {
        return checked
      })
      this.updateCoursesButtonState(enableUpdate)
    })

    /*
     * Submit AJAX request to server to update the selected child courses.
     */
    $('#update-courses').click(() => {
      var coursenums = $('.select-child-course:checked')
        .toArray()
        .map(function (el) {
          return $(el).val()
        })
      var title = 'Update Child Courses'
      var message = `You are about to update ${coursenums.length} ${
        coursenums.length === 1 ? 'course' : 'courses'
      } to the most recent master version.  Are you sure you want to do this?`
      var yesFunction = () => {
        $.post(
          `/author/update.children_to_latest_master/${this.coursenum}`,
          {
            coursenums: coursenums.join(','),
          },
          function () {
            window.location.reload()
          }
        )
      }
      var buttons = {
        'Yes, update child courses': yesFunction,
        'No, I changed my mind': undefined,
      }
      $.meDialog.confirm(
        title,
        message,
        buttons,
        undefined,
        {},
        'btn btn-danger btn-myed btn-danger-myed'
      )
    })
  }

  updateCoursesButtonState(state) {
    var updateCoursesButton = $('#update-courses')
    updateCoursesButton.toggleClass('disabled', !state)
    updateCoursesButton.toggleClass('btn-default', !state)
    updateCoursesButton.toggleClass(
      'btn-danger btn-myed btn-danger-myed',
      state
    )
  }
}
